import {gsap} from "../LibrariesImport";

export default class BlockRealizationLight {
	constructor() {
		this.blocks = document.querySelectorAll(".block-realization-light");

		if (!this.blocks) {
			return;
		}

		this.buildSliders();
	}

	buildSliders() {
		this.blocks.forEach(block => {
			const slider = block.querySelector(".swiper");
			const swiperPagination = block.querySelector(".swiper-custom-pagination-fraction");
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");

			const fmt = n => n < 10 ? '0' + n : n;

			const swiper = new Swiper(slider, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				breakpoints: {
					768: {
						slidesPerView: 2,
					}
				},
				speed: 500,
				spaceBetween: 20,
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});

			const updatePagination = () => {
				swiperPagination.innerHTML = `<span class="swiper-pagination-current">${fmt(swiper.realIndex + 1)}</span> / <span>${fmt(swiper.slides.length)}</span>`;
			};

			updatePagination();
			swiper.on('slideChange', updatePagination);

		});
	}

}
